import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useSession } from '@supabase/auth-helpers-react';

const PrivateRoute = ({ children }) => {
  const session = useSession();
  const location = useLocation();
  return session ? children : <Navigate to="/login" state={{ from: location }} replace />;
};

export default PrivateRoute;
